const initTrackingAction =
  () =>
  (dispatch, getState, { tracking }) => {
    tracking.registerGetState(getState);
    tracking.registerDispatch(dispatch);
  };

export default initTrackingAction;
